import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

export const SaveChangesModal = ({
	onStay,
	onDiscardAndLeave,
	onSaveAndLeave,
	isOpen,
	isSaving,
	rerateRequired,
}: {
	onStay: () => void;
	onDiscardAndLeave: () => void;
	onSaveAndLeave: () => void;
	isOpen: boolean;
	isSaving: boolean;
	rerateRequired: boolean;
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<TraxModal
			canLeave={true}
			canLeaveText={"Leave without saving"}
			cancelText={"Keep Editing"}
			confirmDisabled={isSaving}
			confirmText={rerateRequired ? "Save & Rerate" : "Save & Exit"}
			onCanLeave={onDiscardAndLeave}
			onCancel={onStay}
			onClose={onStay}
			onConfirm={onSaveAndLeave}
			showButtonsDisabled={isSaving}
			showConfirmationButtons={true}
			title={"Changes Won't Be Saved"}
			type={"error"}
			width={"30%"}
		>
			<div>
				If you leave now, all changes will be lost. Select{" "}
				{rerateRequired ? '"Save & Rerate"' : '"Save & Exit"'} to save your
				changes, or &quot;Keep Editing&quot; to make additional updates.
			</div>
		</TraxModal>
	);
};
